module.exports = __webpack_public_path__ + "b93a5df41198f45c7a525cd6549ef601.gif";